import { RowAction } from '../common-table';
import { ICommonTableColumn, ICommonTableConfig, IFilterValues, SortConfig } from './common-table.interface';
import { IRequestMeta } from '../../../typing/response.interface';

export class CommonTableConfig implements ICommonTableConfig {
    columns: ICommonTableColumn[];
    showRowMenu: boolean;
    withCheckboxes: boolean;
    paginatorConfig: IRequestMeta;
    sortConfig?: SortConfig;
    filters?: IFilterValues;
    title?: string;
    rowActions?: RowAction[];
    showCreateButton?: boolean;
    createButtonLabel?: string;
    displayedColumns?: string[];

    constructor(data: Partial<ICommonTableConfig>) {
        this.columns = data.columns || [];
        this.showRowMenu = data.showRowMenu || false;
        this.withCheckboxes = data.withCheckboxes || false;
        this.paginatorConfig = data.paginatorConfig || {
            itemsPerPage: 10,
            totalItems: 0,
            currentPage: 1,
            totalPages: 0,
        };
        this.sortConfig = data.sortConfig;
        this.filters = data.filters;
        this.title = data.title;
        this.showCreateButton = data.showCreateButton || false;
        this.createButtonLabel = data.createButtonLabel || 'Добавить';
        this.displayedColumns = data.displayedColumns || undefined;
    }
}
